import * as React from "react";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean;
  checked?: boolean;
}

export class Checkbox extends React.Component<IProps> {
  private input: HTMLInputElement | null = null;

  public render() {
    const { indeterminate, ...props } = this.props;
    return (
      <input {...props} ref={this.onRef} readOnly={true} type="checkbox" />
    );
  }

  public componentDidUpdate(prevProps: IProps) {
    if (this.input && prevProps.indeterminate !== this.props.indeterminate) {
      this.input.indeterminate = !!this.props.indeterminate;
    }
  }

  private onRef = (input: HTMLInputElement | null) => {
    this.input = input;
    if (input) {
      input.indeterminate = !!this.props.indeterminate;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Checkbox.tsx